import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIcMoveJob({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 4.736h4.266c1.235 0 2.234 1.02 2.234 2.279v2.693h-4.875V8.672a.62.62 0 0 0-.61-.621.62.62 0 0 0-.609.621v1.036H6.094V8.672a.62.62 0 0 0-.61-.621.62.62 0 0 0-.609.621v1.036H0V7.015c0-1.26 1-2.28 2.234-2.28H6.5v-.828c0-.914.728-1.657 1.625-1.657h3.25c.896 0 1.624.743 1.624 1.658v.828Zm-4.875 0v-.828h3.25v.828h-3.25Zm10.533 7.02a.749.749 0 0 1 .622.214l4.375 4.375a.75.75 0 0 1 0 1.06L19.28 21.78a.75.75 0 1 1-1.06-1.06l3.094-3.095h-6.94a.75.75 0 1 1 .001-1.5h6.94L19.5 14.311l-1.28-1.28a.747.747 0 0 1 0-1.061.747.747 0 0 1 .438-.214Zm-4.033-.042v-.762h2.492a2.25 2.25 0 0 0 .042 3.139l.534.534h-3.318a2.25 2.25 0 0 0-1.124 4.2H2.234C1 18.825 0 17.805 0 16.545v-5.593h4.875v.762c0 .34.276.622.61.622a.62.62 0 0 0 .609-.622v-.762h7.312v.762c0 .34.276.622.61.622a.62.62 0 0 0 .609-.622Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgIcMoveJob.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIcMoveJob
